import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "450px",
    "& .MuiFormHelperText-root": {
      color: "#ffcc00",
    },
  },
  card: {
    borderRadius: "10px",
    color: theme.palette.text.tertiary,
  },
  cardContent: {
    backgroundColor: theme.palette.primary.main,
    padding: "18px 30px ",
    position: "relative",
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: "25px",
    fontWeight: "700",
  },
  closeIcon: {
    color: theme.palette.text.primary,
    cursor: "pointer",
  },
  displayFlex: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  iconStyle: {
    width: "100%",
    marginTop: "18%",
    color: theme.palette.text.primary,
  },

  cardContentDiv1: {
    justifyContent: "space-around",
    marginTop: "5%",
  },
  cardContentDiv2: {
    width: "50%",
    height: "5rem",
    display: "grid",
    placeItems: "center",
    border: `2px solid ${theme.palette.text.primary}`,
  },
  cardContentDiv3: {
    backgroundColor: theme.palette.secondary.light,
    padding: "4px",
    borderRadius: "10px",
  },
  cardContentInput1: {
    padding: "0.2px 6px",
  },
  cardContentInput2: {
    padding: "2px 8px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    width: "100%",
    height: "40px",
  },

  autoComplete: {
    width: "100%",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "5px",
  },
  done: {
    backgroundColor: theme.palette.secondary.main,
    height: "40px",
    textTransform: "none",
    padding: "6px ",
    borderRadius: "7px",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.light,
    },
  },

  cardAction: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "center",
    marginTop: "10px",
    padding: "0px",
  },
  labelText: {
    display: "block",
    borderRadius: "5px",
    color: theme.palette.text.tertiary,
    cursor: "pointer",
    textAlign: "center",
  },
  addNewStatusButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
  },
  defaultButton: {
    color: theme.palette.text.tertiary,
    minWidth: 0,
    padding: "0px",
  },
  selectedButton: {
    color: theme.palette.text.primary,
    minWidth: 0,
    padding: "0px",
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "0px",
  },
}));

export default useStyles;
